import { Component, OnInit, AfterViewInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { AssignTelecallerService, TelecallerMasterService, CommonService } from '../../../services/index';
import { AssignTelecallerModel } from '../../../model/index';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import * as fromCommonStore from '../../../store';

@Component({
    selector: 'assign-telecaller-tab',
    templateUrl: './assignTelecaller.component.html',
    styleUrls: ['./assignTelecaller.component.css']
})
export class AssignTelecallerComponent implements OnInit, AfterViewInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    @ViewChild('assignTelecallerTable') assignTelecallerTable: any;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('willingTemplate') willingTemplate: TemplateRef<any>;
    @ViewChild('statusTemplate') statusTemplate: TemplateRef<any>;
    @ViewChild('assignedTemplate') assignedTemplate: TemplateRef<any>;
    columns = [];
    recordList: AssignTelecallerModel[] = [];
    isLoadMask: Promise<any>;
    loadingIndicator = true;
    reorderable = true;
    followupTeamList: any[] = [];
    telecallerList: any[] = [];
    allTelecallerList: any[] = [];
    selectedFolId: any = '';
    selectedTeamName: string = '';
    selectedRows: any[] = [];
    selectedAssignTo: any = '';

    itemList: any[] = [];
    referenceCtrl: FormControl;
    filteredReference: Observable<any[]>;

    branchList: any[] = [];
    branchCtrl: FormControl;
    filteredBranch: Observable<any[]>;

    assignedToCtrl: FormControl;
    filteredAssignedTo: Observable<any[]>;

    empNameCtrl: FormControl;
    filteredEmpName: Observable<any[]>;
    empNameList: any[] = [];
    private searchTermsEmp = new Subject<string>();

    stats: any = { total: 0, unassigned: 0, telecallers: [] };
    filterExpanded = false;

    filterData = {
        search_data: '',
        assigned_to: '',
        branch_id: '',
        from_date: null,
        to_date: null,
        reference: '',
        employee_id: ''
    };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'cfs.date',
        orderDir: 'asc'
    };

    constructor(
        private assignTelecallerService: AssignTelecallerService,
        private telecallerMasterService: TelecallerMasterService,
        private toasterService: ToasterService,
        private store: Store<any>,
        private commonService: CommonService
    ) { }

    ngOnInit(): void {
        this.referenceCtrl = new FormControl();
        this.filteredReference = this.referenceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.itemList.slice());

        this.store.select(fromCommonStore.getAllReference).subscribe((res: any) => {
            if (res && res.length > 0) {
                this.itemList = res;
            }
        });

        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        this.assignedToCtrl = new FormControl();
        this.filteredAssignedTo = this.assignedToCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterAssignedTo(name) : this.getAssignedToOptions().slice());

        this.empNameCtrl = new FormControl();
        this.filteredEmpName = this.searchTermsEmp
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => term
                ? this.commonService.getEmployeeList(term, 'challan')
                : Observable.of<any[]>([]))
            .catch(() => Observable.of<any[]>([]));
        this.filteredEmpName.subscribe(res => { this.empNameList = res; });

        this.assignTelecallerService.getAllAssignedToList().then((res: any) => {
            if (res && res.data) { this.allTelecallerList = res.data; }
        });

        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (res && res.data && res.data.length > 0) {
                this.branchList = _.filter(res.data, (obj) => obj['is_crm_branch'] === 'Yes');
            }
        });

        this.columns = [
            { prop: 'selected', name: '', width: 60, minWidth: 60, maxWidth: 60, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: true, checkboxable: true },
            { name: 'SNo', prop: 'sno', width: 55, minWidth: 55, maxWidth: 55, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Branch', prop: 'branch_name', sortable: false, width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Assigned To', prop: 'assigned_to_name', sortable: false, width: 130, minWidth: 130, maxWidth: 130, cellTemplate: this.assignedTemplate },
            { name: 'Entry Date', prop: 'date', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Followup Date', prop: 'last_followup_date', sortable: false, width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Client ID', prop: 'client_no', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Name', prop: 'client_name', sortable: false, width: 160, minWidth: 160, maxWidth: 160 },
            { name: 'Reference', prop: 'reference_name', sortable: false, width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Last Followup Date', prop: 'last_followup_date', sortable: false, width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'Status', prop: 'status_name', sortable: false, width: 180, minWidth: 180, maxWidth: 180, cellTemplate: this.statusTemplate },
            { name: 'Next Followup Date', prop: 'fol_date', width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'Last Followup Emp', prop: 'employee_name', sortable: false, width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'Track', prop: 'no_of_follow', sortable: false, width: 65, minWidth: 65, maxWidth: 65 },
            { name: 'Willing', prop: 'willing', sortable: false, width: 70, minWidth: 70, maxWidth: 70, cellTemplate: this.willingTemplate },
            { name: 'Unsold Remarks', prop: 'unsold_description_name', sortable: false, width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Unsold Reason Details', prop: 'unsold_reason_details', sortable: false, width: 200, minWidth: 200, maxWidth: 200 }
        ];
        this.loadFollowupTeamList();
    }

    ngAfterViewInit(): void {
    }

    loadFollowupTeamList(): void {
        this.telecallerMasterService.getFollowupTeamList().then((res: any) => {
            if (res && res.data) {
                this.followupTeamList = res.data;
            }
        });
    }

    onTeamChange(): void {
        const team = this.followupTeamList.find(t => t.followup_team_id == this.selectedFolId);
        this.selectedTeamName = team ? team.team_name : '';
        this.selectedRows = [];
        this.selectedAssignTo = '';
        this.telecallerList = [];
        this.stats = { total: 0, unassigned: 0, telecallers: [] };
        this.recordList = [];
        this.page.count = 0;
        this.referenceCtrl.setValue('');
        this.branchCtrl.setValue('');
        this.assignedToCtrl.setValue('');
        this.empNameCtrl.setValue('');

        if (!this.selectedFolId) return;

        this.assignTelecallerService.getTelecallerList({ fol_id: this.selectedFolId }).then((res: any) => {
            if (res && res.data) {
                this.telecallerList = res.data;
            }
        });

        this.filterData = { search_data: '', assigned_to: 'all', branch_id: '', from_date: null, to_date: null, reference: '', employee_id: '' };
        this.page.offset = 0;
        this.getRecordList();
    }

    pageCallback(pageInfo: { page?: number }): void {
        if (!pageInfo.page) return;
        const newOffset = pageInfo.page - 1;
        if (newOffset === this.page.offset) return;
        this.page.offset = newOffset;
        this.getRecordList();
    }

    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[] }): void {
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.getRecordList();
    }

    onChangePageSize(limit): void {
        this.page.limit = limit;
        this.getRecordList();
    }

    clearFilter(): void {
        this.filterData = { search_data: '', assigned_to: '', branch_id: '', from_date: null, to_date: null, reference: '', employee_id: '' };
        this.referenceCtrl.setValue('');
        this.branchCtrl.setValue('');
        this.assignedToCtrl.setValue('');
        this.empNameCtrl.setValue('');
        this.applyFilter();
    }

    applyFilter(): void {
        this.page.offset = 0;
        this.getRecordList();
    }

    getRecordList(): void {
        if (!this.selectedFolId) return;

        let params: any = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            fol_id: `${this.selectedFolId}`,
            search_data: this.filterData.search_data,
            assigned_to: this.assignedToCtrl.value || '',
            branch_id: this.branchCtrl.value || '',
            reference: this.referenceCtrl.value || '',
            employee_id: this.empNameCtrl.value || ''
        };

        if (_.isDate(this.filterData.from_date)) {
            params.from_date = moment(this.filterData.from_date).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData.to_date)) {
            params.to_date = moment(this.filterData.to_date).format('YYYY-MM-DD');
        }

        this.isLoadMask = this.assignTelecallerService.getRecordList(params).then((res: any) => {
            this.loadingIndicator = false;
            this.page.count = res.totCnt;
            this.recordList = res.data || [];
            this.selectedRows = [];
            if (res.stats) {
                this.stats = res.stats;
            }
        });
    }

    onSelect(event: any): void {
        this.selectedRows = event.selected;
    }

    assignSelected(): void {
        if (!this.selectedAssignTo) {
            this.toasterService.pop('warning', 'Warning', 'Please select a telecaller to assign.');
            return;
        }
        if (!this.selectedRows || this.selectedRows.length === 0) {
            this.toasterService.pop('warning', 'Warning', 'Please select at least one record.');
            return;
        }

        const stIds = this.selectedRows.map((r: any) => r.st_id).join(',');
        const data = { assign_userid: this.selectedAssignTo, st_ids: stIds };

        this.assignTelecallerService.assignSelected(data).then((res: any) => {
            if (res && res.success) {
                this.toasterService.pop('success', 'Success', res.message);
                this.selectedRows = [];
                this.getRecordList();
            } else {
                this.toasterService.pop('error', 'Error', res.message || 'Assignment failed.');
            }
        });
    }

    onAutoDistribute(): void {
        if (!this.selectedFolId) return;

        this.assignTelecallerService.autoDistributePreview({ fol_id: this.selectedFolId }).then((res: any) => {
            if (!res || !res.success) {
                this.toasterService.pop('error', 'Error', res.message || 'No unassigned records found.');
                return;
            }

            let tableHtml = '<table style="width:100%;border-collapse:collapse;font-size:13px;">';
            tableHtml += '<thead><tr style="background:#1a3a8f;color:#fff;"><th style="padding:6px 10px;">Slot</th><th style="padding:6px 10px;">Name</th><th style="padding:6px 10px;">Records</th></tr></thead><tbody>';
            res.preview.forEach((tc: any, i: number) => {
                const bg = i % 2 === 0 ? '#f5f5f5' : '#fff';
                tableHtml += `<tr style="background:${bg};"><td style="padding:5px 10px;">${tc.telecaller_slot}</td><td style="padding:5px 10px;">${tc.fullname}</td><td style="padding:5px 10px;text-align:center;">${tc.count}</td></tr>`;
            });
            tableHtml += '</tbody></table>';

            swal({
                title: 'Auto Distribute Preview',
                html: `<p style="margin-bottom:10px;">Total records: <strong>${res.total}</strong> across <strong>${res.tc_count}</strong> telecaller(s)</p>${tableHtml}`,
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Distribute',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#1a3a8f'
            }).then(() => {
                this.doAutoDistribute();
            }).catch(() => {});
        });
    }

    doAutoDistribute(): void {
        this.assignTelecallerService.autoDistribute({ fol_id: this.selectedFolId }).then((res: any) => {
            if (res && res.success) {
                this.toasterService.pop('success', 'Success', res.message);
                this.getRecordList();
            } else {
                this.toasterService.pop('error', 'Error', res.message || 'Distribution failed.');
            }
        });
    }

    onRedistributeAll(): void {
        if (!this.selectedFolId) return;

        this.assignTelecallerService.redistributeAllPreview({ fol_id: this.selectedFolId }).then((res: any) => {
            if (!res || !res.success) {
                this.toasterService.pop('error', 'Error', res.message || 'No records found.');
                return;
            }

            let tableHtml = '<table style="width:100%;border-collapse:collapse;font-size:13px;">';
            tableHtml += '<thead><tr style="background:#c0392b;color:#fff;"><th style="padding:6px 10px;">Slot</th><th style="padding:6px 10px;">Name</th><th style="padding:6px 10px;">Records</th></tr></thead><tbody>';
            res.preview.forEach((tc: any, i: number) => {
                const bg = i % 2 === 0 ? '#f5f5f5' : '#fff';
                tableHtml += `<tr style="background:${bg};"><td style="padding:5px 10px;">${tc.telecaller_slot}</td><td style="padding:5px 10px;">${tc.fullname}</td><td style="padding:5px 10px;text-align:center;">${tc.count}</td></tr>`;
            });
            tableHtml += '</tbody></table>';

            swal({
                title: 'Redistribute All Records',
                html: `<p style="margin-bottom:6px;color:#c0392b;font-weight:bold;">This will reassign ALL ${res.total} record(s) across ${res.tc_count} telecaller(s).</p>${tableHtml}`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Redistribute',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#c0392b'
            }).then((result) => {
                if (result.value) {
                    this.doRedistributeAll();
                }
            });
        });
    }

    doRedistributeAll(): void {
        this.assignTelecallerService.redistributeAll({ fol_id: this.selectedFolId }).then((res: any) => {
            if (res && res.success) {
                this.toasterService.pop('success', 'Success', res.message);
                this.getRecordList();
            } else {
                this.toasterService.pop('error', 'Error', res.message || 'Redistribution failed.');
            }
        });
    }

    getTotalTcCount(): number {
        if (!this.stats || !this.stats.telecallers) return 0;
        return this.stats.telecallers.reduce((sum: number, tc: any) => sum + (tc.record_count || 0), 0);
    }

    getProgressPct(count: number): number {
        if (!this.stats || !this.stats.total || this.stats.total === 0) return 0;
        return Math.round((count / this.stats.total) * 100);
    }

    getAssignedToOptions(): any[] {
        return [
            { userid: 'unassigned', fullname: 'Unassigned' },
            ...this.allTelecallerList
        ];
    }

    filterAssignedTo(name: string) {
        name = _.escapeRegExp(name);
        return this.getAssignedToOptions().filter(item =>
            new RegExp(name, 'gi').test(item.fullname)
        );
    }

    displayAssignedToFn(userid: any) {
        if (!userid) return '';
        const found = _.find(this.getAssignedToOptions(), { userid });
        return found ? found['fullname'] : '';
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }

    displayBranchFn(branchID: number) {
        if (branchID && this.branchList.length > 0) {
            const branchObj = _.find(this.branchList, { 'branch_id': branchID });
            return branchObj ? branchObj['branch_name'] : '';
        }
        return '';
    }

    filterItems(name: string) {
        if (!this.itemList) return [];
        return this.itemList.filter(item =>
            (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name))
        );
    }

    displayRef(item_id: number) {
        if (item_id && this.itemList && this.itemList.length > 0) {
            const fitem = _.find(this.itemList, { 'ref_id': item_id });
            return fitem ? fitem['name'] : '';
        }
        return '';
    }

    searchEmployee(query: string) {
        this.searchTermsEmp.next(query);
    }

    displayEmpName(empID: any) {
        if (!empID || !this.empNameList || !this.empNameList.length) return '';
        const found = _.find(this.empNameList, { empid: empID }) || _.find(this.empNameList, { userid: empID });
        return found ? (found['empname'] || found['fullname']) : '';
    }

    getSlotShortLabel(slot: string): string {
        if (!slot) return '';
        const m = slot.match(/\d+/);
        return m ? 'TC ' + m[0] : slot.substring(0, 5);
    }

    getTcChipClass(index: number): string {
        const classes = ['at-sc-purple', 'at-sc-orange', 'at-sc-green', 'at-sc-blue'];
        return classes[index % classes.length];
    }

    getTcColor(index: number): string {
        const colors = ['#6a1b9a', '#e65100', '#2e7d32', '#1565c0', '#00897b', '#b71c1c'];
        return colors[index % colors.length];
    }

    getSlotColor(slot: string): string {
        if (!slot) return '#555';
        if (slot === 'Telecaller 1') return '#3f51b5';
        if (slot === 'Telecaller 2') return '#8e24aa';
        if (slot === 'Telecaller 3') return '#e65100';
        const colors = ['#00897b', '#f4511e', '#039be5', '#7cb342', '#c0ca33'];
        let hash = 0;
        for (let i = 0; i < slot.length; i++) { hash = slot.charCodeAt(i) + ((hash << 5) - hash); }
        return colors[Math.abs(hash) % colors.length];
    }

    getStatusColor(status: string): string {
        if (!status) return '#888';
        const s = status.toLowerCase();
        if (s.includes('willing') && !s.includes('not')) return '#43a047';
        if (s.includes('call back')) return '#fb8c00';
        if (s.includes('not reachable')) return '#e53935';
        if (s.includes('appointment')) return '#00897b';
        if (s.includes('not willing') || s.includes('cancel')) return '#b71c1c';
        if (s.includes('done') || s.includes('sold')) return '#1565c0';
        return '#607d8b';
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/assignTelecaller/assignTelecaller.component.ts